"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("./_commonjsHelpers.cjs"),t=require("../node_modules/extend/index.cjs");var r=t.__require();const o=e.getDefaultExportFromCjs(r);exports.default=o;
//# sourceMappingURL=index.cjs.map
